import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    header: {
      title: translate({
        id: 'modal.unableToCreateRecurrentOrdersModal.confirmDiscard.header.title',
      }),
    },
    body: {
      description: translate({
        id: 'modal.unableToCreateRecurrentOrdersModal.confirmDiscard.body.description',
      }),
    },

    footer: {
      discard: translate({
        id: 'modal.unableToCreateRecurrentOrdersModal.confirmDiscard.footer.discard',
      }),
      cancel: translate({
        id: 'modal.unableToCreateRecurrentOrdersModal.confirmDiscard.footer.cancel',
      }),
    },
  }))

  return api
}
